module.exports = __webpack_public_path__ + "img/Wonder.e7a947b3.svg";